import styles from "./ContactPage.module.scss"

export const SuccessView = () => {
  return (
    <div className={styles.successView}>
      <h1>Thank you for your message!</h1>
      <p>We will get back to you as soon as possible.</p>
    </div>
  )
}
